import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Backdrop, CircularProgress, Divider } from '@mui/material';
import useAddonDialogState from './useAddonDialogState';

import BasicFields from './sections/BasicFields';
import CreatedAtField from './sections/CreatedAtField';
import AddonFilesField from './sections/AddonFilesField';
import ImagesField from './sections/ImagesField';
import DownloadsEditor from './sections/DownloadsEditor';
import TagsEditor from './sections/TagsEditor';

export default function AddonDialog({ open, mode, editing, onClose, onSubmit }) {
  const { isEdit, refs, state, actions } = useAddonDialogState({
    open,
    mode,
    editing,
    onSubmit,
    onClose,
  });

  return (
    <Dialog open={open} onClose={state.saving ? undefined : onClose} maxWidth="md" fullWidth>
      <DialogTitle>{isEdit ? 'Edit Addon' : 'New Addon'}</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <BasicFields
            title={state.title}
            text={state.text}
            saving={state.saving}
            onTitleChange={actions.setTitle}
            onTextChange={actions.setText}
          />

          <CreatedAtField value={state.createdAt} saving={state.saving} onChange={actions.onCreatedAtChange} />

          <Divider />
          <AddonFilesField
            saving={state.saving}
            addonFiles={state.addonFiles}
            inputRef={refs.addonFilesRef}
            onChange={actions.onAddonFilesChange}
            onRemove={actions.removeAddonFileAt}
          />

          <ImagesField
            isEdit={isEdit}
            saving={state.saving}
            imgsKeep={state.imgsKeep}
            imgPreviews={state.imgPreviews}
            imgsInputRef={refs.imgsRef}
            onImgsChange={actions.onImgsChange}
            onRemoveKeep={actions.removeKeepImgAt}
            onMoveKeep={actions.moveKeepImg}
            onRemoveNew={actions.removeNewImgAt}
          />

          {isEdit && (
            <>
              <Divider />

              <TagsEditor
                saving={state.saving}
                tags={state.tags}
                onChangeTags={actions.setTags}
              />

              <Divider />

              <DownloadsEditor
                saving={state.saving}
                downloads={state.downloads}
                onChange={actions.updateDownloadField}
                onAdd={actions.addDownload}
                onRemove={actions.removeDownloadAt}
              />
            </>
          )}

        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={state.saving}>
          Cancel
        </Button>
        <Button onClick={actions.submit} variant="contained" disabled={state.saving}>
          Save
        </Button>
      </DialogActions>

      <Backdrop
        open={state.saving}
        sx={{
          position: 'absolute',
          color: '#fff',
          zIndex: (theme) => theme.zIndex.modal + 1,
          backgroundColor: 'rgba(0,0,0,0.30)',
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}
